import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";
import Url from "@core/scripts/helper/url";
import Logger from "@core/scripts/components/logger";

export default function submitAvailabilityReminderHandler(email, newsletterPermission, styleId, itemId, itemOptionId, price, successFunction) {
    fetchWithCSRF(Url.toAbsolute('/ajax/remind/'),
        {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            }),
            body: JSON.stringify({
                email,
                newsletterPermission,
                styleId,
                itemId,
                itemOptionId,
                price
            }),
            accepts: {
                text: 'application/json'
            },
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error('error submitting availability reminder');
            }
            return response.json();
        })
        .then(data => successFunction(data, email))
        .catch((error) => {
            Logger.error('Could not post for reminder email', error);
            successFunction({ success: false, newsletterSubscriptionResponse: null }, email);
        });
}
